<template>
  <div
    @click="navigateToProductPage"
    class="mx-autod-md-block product-card v-card v-card--link v-sheet theme--light"
    max-width="400"
    flat
  >
    <div v-if="product.images" class="product-image-container">
      <img
        class="product-image"
        v-if="product.images.length > 0"
        :src="product.images[0].imageUrl"
        :alt="product.name"
      />
      <img
        class="product-image"
        v-else
        src="https://i.stack.imgur.com/y9DpT.jpg"
        width="100%"
        :alt="product.name"
      />
    </div>
    <div class="v-card__text text--primary">
      <div class="d-flex justify-space-between">
        <div class="gotham-medium font-16 product-title">
          {{ product.name }}
        </div>
        <!-- <img src="@/assets/product-logo.svg" width="26" /> -->
      </div>
      <div class="d-flex align-center">
        <img class="tag-icon" :src="require('@/assets/tag.svg')" />
        <span class="product-tag ml-1">{{ product.subCategories | subCategoriesFilter }}</span>
      </div>
      <div class="product-price mt-2 mb-10">
        <span class="gotham-medium" v-if="isLoggedIn"
          >£ {{ product.amount }}
        </span>
      </div>
      <div class="d-flex justify-space-between product-footer pb-3">
        <div>
          <div class="d-flex">
            <div class="d-flex">
              <i
                v-for="index in 5"
                :key="index"
                :class="{
                  'appOrange--text': index < product.reviewRating.average,
                  'appLightGrey100--text': index >= product.reviewRating.average,
                  'appLightGrey100--text': product.reviewRating.average== undefined
                  
                }"
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-star theme--light v-rating"
              ></i>
            </div>
            <span class="ml-1 gotham-book font-14 text--lighten-1"
              >({{ product.reviewRating.outOf ? product.reviewRating.outOf : 0 }})</span
            >
          </div>
          <!-- <div class="gotham-book product-sales">301 Sales</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DiscountLabel from "@/components/Shared/DiscountLabel/DiscountLabel.vue";
export default {
  name: "ProductCard",
  props: {
    product: Object,
    discount: {
      type: Boolean,
      default: true
    }
  },
  // components: {
  //   DiscountLabel
  // },
  filters: {
    subCategoriesFilter(subCategories) {
     return (subCategories.length < 1) ? 'Uncategorised' : subCategories[0].label;
    }
  },
  data: () => ({
    rating: 5,
    carousel: 0
  }),
  computed: {
    isLoggedIn() {
      return this.$store.state.auth.token !== null ? true : false;
    }
  },
  methods: {
    navigateToProductPage() {
      this.evtProductClicked(this.product);
      this.$router.push({
        name: "Product",
        params: {
          id: this.convertToSlug(this.product.name) + "-" + this.product.id
        }
      });
    },
    convertToSlug(Text) {
      return Text.toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "-");
    }
  }
};
</script>

<style scoped lang="scss" src="./ProductCard.scss"></style>
